// Explicitly opt-in, read-only preview data. Never used for authenticated billing.
export function cancellationPreviewData(state = 'pending') {
  const paid = state === 'paid';
  const cancelled = state === 'cancelled';
  return {
    list: [{
      id: 'demo-alipay-cancellation', order_no: 'DEMO-ALIPAY-001',
      subject: '个人订阅 · 专业版 · 按月（演示）', credits: 4100, total_amount: '329.00',
      status: state, status_label: paid ? '已完成' : cancelled ? '已取消' : '待支付',
      created_at: '2026-09-07T16:01:02+08:00', paid_at: paid ? '2026-09-07T16:16:03+08:00' : null,
      cancellation_requested: state === 'pending', cancel_requested_at: '2026-09-07T16:16:04+08:00',
      payments: [{
        id: 'demo-payment', pay_no: 'DEMO-PAYMENT-001', channel: 'alipay_page', channel_label: '支付宝',
        status: paid ? 'success' : cancelled ? 'closed' : 'pending',
        status_label: paid ? '支付成功' : cancelled ? '已关闭' : '待支付',
        created_at: '2026-09-07T16:01:02+08:00', can_cancel: false, cancellation_pending: state === 'pending',
      }],
    }],
    total: 1, page: 1, per_page: 10,
    summary: { total_orders: 1, paid_orders: paid ? 1 : 0, refund_orders: 0, paid_amount: paid ? '329.00' : '0.00' },
  };
}
